<template>
  <div class="empty_content">
    <div class="empty_content--content">
      <h4 class="empty_content--heading">{{ heading }}</h4>
      <p class="empty_content--message">
        <slot></slot>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "EmptyRecords",
  props: {
    heading: String,
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.empty_content {
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.empty_content--content {
  margin-top: -25%;
  padding: 4rem 6rem;
  border: 1px solid $borderDark;
  text-align: center;
}

.empty_content--heading {
  color: $text-light;
  font-size: 2rem;
  font-style: italic;
}

.empty_content--message {
  max-width: 800px;
  margin-top: 12px;
  color: $text-light;
  font-size: 1.25rem;
  font-style: italic;
  line-height: 1.5;
}
</style>
